module.exports = __webpack_public_path__ + "img/usone.c6a93ac2.png";